export const fetchDeployedAppVersion = async (): Promise<string | null> => {
  const response = await fetch(`${import.meta.env.BASE_URL}version.json`, {
    cache: 'no-store',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch version.json: ${response.status}`);
  }

  const body: unknown = await response.json();

  if (
    typeof body === 'object' &&
    body !== null &&
    'version' in body &&
    typeof body.version === 'string'
  ) {
    return body.version;
  }

  return null;
};

export const isAppUpdateAvailable = (
  runningVersion: string | undefined,
  deployedVersion: string | null | undefined,
): deployedVersion is string =>
  !!runningVersion && !!deployedVersion && runningVersion !== deployedVersion;
